let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2RoFR")).then(() => parcelRequire('7eU9s'));